import type { Manhwa, Category, FAQItem, Testimonial } from '@/types';

export const categories: Category[] = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { id: 'romance', name: '浪漫爱情', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻冒险', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'action', name: '热血动作', slug: 'action', icon: 'ri-sword-line' },
  { id: 'thriller', name: '悬疑惊悚', slug: 'thriller', icon: 'ri-emotion-line' },
  { id: 'comedy', name: '搞笑日常', slug: 'comedy', icon: 'ri-emotion-happy-line' },
  { id: 'drama', name: '剧情人生', slug: 'drama', icon: 'ri-movie-line' },
  { id: 'bl', name: 'BL专区', slug: 'bl', icon: 'ri-user-heart-line' },
];

export const manhwaList: Manhwa[] = [
  {
    id: 1,
    title: '某天成为公主',
    altTitle: '어느 날 공주가 되어버렸다',
    author: 'Plutus / Spoon',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20princess%20with%20long%20blonde%20hair%20wearing%20an%20elegant%20royal%20dress%2C%20soft%20watercolor%20texture%2C%20dreamy%20atmosphere%2C%20pastel%20color%20palette%2C%20fantasy%20royalty%20theme%2C%20delicate%20art%20style%2C%20golden%20accents%2C%20ethereal%20lighting&width=600&height=800&seq=manhwa-cover-01&orientation=portrait',
    description: '醒来发现自己成了小说中的公主，还是那个注定要被父亲杀害的悲情公主？为了改变命运，她开始了一段温馨又惊险的宫廷生活。',
    rating: 9.7,
    views: '1280万',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: 156,
    tags: ['穿越', '宫廷', '治愈', '画风精美'],
  },
  {
    id: 2,
    title: '我独自升级',
    altTitle: '나 혼자만 레벨업',
    author: 'Chugong / Dubu',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20black%20hair%20and%20glowing%20blue%20eyes%20in%20a%20black%20coat%2C%20dramatic%20lighting%2C%20action%20pose%2C%20dark%20urban%20fantasy%20setting%2C%20intense%20atmosphere%2C%20sharp%20line%20art%2C%20cool%20color%20tones&width=600&height=800&seq=manhwa-cover-02&orientation=portrait',
    description: '连接异次元的"门"出现，觉醒者们在此战斗。被称为人类最弱兵器的成振宇，在一次双重 dungeon 中濒死，醒来后发现自己获得了独一无二的升级系统。',
    rating: 9.9,
    views: '3560万',
    status: '已完结',
    updateTime: '2026-07-20',
    chapters: 179,
    tags: ['系统', '战斗', '升级', '热血'],
  },
  {
    id: 3,
    title: '恶女是提线木偶',
    altTitle: '악녀는 마리오네트',
    author: 'Hanirim / Manggle',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20style%20illustration%20of%20a%20noble%20lady%20with%20long%20silver%20hair%20and%20red%20eyes%20in%20a%20luxurious%20gothic%20dress%2C%20elegant%20and%20mysterious%20atmosphere%2C%20palace%20ballroom%20background%2C%20ornate%20details%2C%20dramatic%20romantic%20mood%2C%20soft%20rim%20lighting&width=600&height=800&seq=manhwa-cover-03&orientation=portrait',
    description: '凯耶娜·希尔——帝国最著名的恶女。被当作政治棋子的她，决定不再做任何人手中的木偶，开始谋划自己的命运。',
    rating: 9.5,
    views: '980万',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: 82,
    tags: ['恶女', '宫廷', '重生', '权谋'],
  },
  {
    id: 4,
    title: '全知读者视角',
    altTitle: '전지적 독자 시점',
    author: 'sing N song / Sleepy-C',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20a%20white%20coat%20holding%20a%20book%20with%20mysterious%20symbols%2C%20apocalyptic%20cityscape%20background%2C%20dramatic%20sky%2C%20constellation%20patterns%2C%20sci-fi%20fantasy%20elements%2C%20cinematic%20composition&width=600&height=800&seq=manhwa-cover-04&orientation=portrait',
    description: '金独子是唯一读完长达3149章网络小说"在灭亡的世界中生存的三种方法"的人。当小说中的世界变成现实，作为唯一知晓全部剧情的他，故事才刚刚开始。',
    rating: 9.8,
    views: '2890万',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: 210,
    tags: ['末世', '系统', '剧情', '智斗'],
  },
  {
    id: 5,
    title: '她的沈清',
    altTitle: '그녀의 심청',
    author: 'Seri / Biwan',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20historical%20drama%20style%20illustration%20of%20two%20women%20in%20traditional%20Korean%20hanbok%20dresses%2C%20one%20in%20bright%20colors%20one%20in%20subdued%20tones%2C%20traditional%20Korean%20village%20scenery%2C%20emotional%20connection%2C%20watercolor%20and%20ink%20art%20style%2C%20warm%20autumn%20leaves&width=600&height=800&seq=manhwa-cover-05&orientation=portrait',
    description: '沈清自愿成为海神的祭品，以换取失明父亲重见光明。这个古老的传说在全新的演绎下展现出更为复杂的人性与情感交织。',
    rating: 9.6,
    views: '560万',
    status: '已完结',
    updateTime: '2026-06-15',
    chapters: 88,
    tags: ['古典', '人性', '情感', '获奖作品'],
  },
  {
    id: 6,
    title: '时间停止的勇者',
    altTitle: '시간을 멈추는 용사',
    author: 'Myoung rang / Danbi',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20manhwa%20fantasy%20comedy%20style%20illustration%20of%20a%20male%20adventurer%20with%20a%20surprised%20expression%20frozen%20in%20time%2C%20surrounded%20by%20monsters%2C%20colorful%20and%20playful%20art%20style%2C%20dynamic%20composition%2C%20bright%20vibrant%20colors%2C%20comic%20fantasy%20adventure&width=600&height=800&seq=manhwa-cover-06&orientation=portrait',
    description: '拥有停止时间能力的勇者，却总是在关键时刻碰到意想不到的尴尬情况。一场充满笑料的异世界冒险喜剧！',
    rating: 9.1,
    views: '750万',
    status: '连载中',
    updateTime: '2026-08-02',
    chapters: 95,
    tags: ['搞笑', '异世界', '冒险', '轻松'],
  },
  {
    id: 7,
    title: '杀死黑帮老大的方法',
    altTitle: '킬러 배드로의 귀환',
    author: 'HUI / Suri',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20intense%20Korean%20manhwa%20thriller%20style%20illustration%20of%20a%20man%20in%20a%20suit%20with%20cold%20eyes%20holding%20a%20weapon%2C%20rainy%20urban%20night%20city%20background%2C%20neo-noir%20atmosphere%2C%20high%20contrast%20lighting%2C%20cinematic%20composition%2C%20gritty%20realistic%20style&width=600&height=800&seq=manhwa-cover-07&orientation=portrait',
    description: '警察厅王牌刑警意外穿越，附身到首尔最大黑帮组织的二把手身上。他决定用刑警的思维和手段，从内部瓦解这个庞大的犯罪帝国。',
    rating: 9.4,
    views: '1120万',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: 134,
    tags: ['黑帮', '卧底', '悬疑', '动作'],
  },
  {
    id: 8,
    title: '钢铁帝王之剑',
    altTitle: '철혈의 제왕',
    author: 'LEE Chung / JADE',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20martial%20arts%20style%20illustration%20of%20a%20warrior%20with%20long%20black%20hair%20wielding%20a%20massive%20sword%2C%20ancient%20Korean%20palace%20background%2C%20epic%20battle%20atmosphere%2C%20dynamic%20action%20pose%2C%20detailed%20armor%2C%20golden%20sunset%20lighting&width=600&height=800&seq=manhwa-cover-08&orientation=portrait',
    description: '被誉为帝国最强的剑术大师，在一场背叛中身亡。当他再次睁眼时，发现自己回到了二十年前——这一次，他要用手中之剑改写一切。',
    rating: 9.3,
    views: '670万',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: 67,
    tags: ['武侠', '重生', '复仇', '热向'],
  },
];

export const featuredManhwa = manhwaList.slice(0, 4);

export const latestUpdates = [...manhwaList].sort((a, b) => 
  new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
);

export const faqItems: FAQItem[] = [
  {
    id: 1,
    question: '虚空韩漫网上的漫画可以免费观看吗？',
    answer: '虚空韩漫网提供大量韩国漫画的免费在线阅读服务。我们持续更新热门韩漫资源，无需注册即可享受流畅的阅读体验。部分独家授权内容可能需要登录后查看。',
  },
  {
    id: 2,
    question: '网站多久更新一次漫画章节？',
    answer: '我们会在原作更新的第一时间进行同步，热门连载作品通常每周更新1-2次。您可以在首页的"最新更新"区域查看最近更新的漫画列表，也可以通过收藏功能实时追踪您喜爱的作品。',
  },
  {
    id: 3,
    question: '如何在手机上阅读韩漫？',
    answer: '虚空韩漫网采用响应式设计，完美适配手机、平板和电脑等多种设备。您只需在手机浏览器中打开我们的网站，即可享受专为移动端优化的竖屏阅读模式，操作简单流畅。',
  },
  {
    id: 4,
    question: '支持哪些阅读模式？',
    answer: '我们支持多种阅读模式：滚动翻页（适合手机竖屏阅读）、左右翻页（模拟纸质漫画阅读体验）以及自动滚动模式。您可以根据自己的阅读习惯自由切换。',
  },
  {
    id: 5,
    question: '可以下载漫画离线阅读吗？',
    answer: '目前我们主要提供在线阅读服务。部分已完结作品支持缓存功能，您可以在有网络的环境下预先加载章节内容，方便在网络不佳时继续阅读。具体功能请以各作品的详情页面说明为准。',
  },
  {
    id: 6,
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过页面顶部的搜索框输入漫画名称、作者名或相关关键词进行搜索。此外，我们还提供了详细的分类导航，您可以按照题材类型（浪漫爱情、奇幻冒险、热血动作等）浏览感兴趣的漫画作品。',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '漫画迷小龙',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20young%20Asian%20person%2C%20clean%20illustration%20style%2C%20warm%20tones%2C%20simple%20background&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    comment: '追了两年韩漫，虚空韩漫网的更新速度是我见过最快的！画质也好，手机看特别舒服。',
    rating: 5,
  },
  {
    id: 2,
    name: '深夜读书人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20young%20Asian%20female%2C%20clean%20illustration%20style%2C%20soft%20colors%2C%20simple%20background&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    comment: '分类做得很细致，找漫画特别方便。最喜欢的是收藏功能，追更不用愁。',
    rating: 5,
  },
  {
    id: 3,
    name: '漫画猎人K',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20young%20person%20with%20glasses%2C%20clean%20illustration%20style%2C%20neutral%20colors%2C%20simple%20background&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    comment: '资源真的很全，很多冷门韩漫都能在这里找到。界面设计也很清爽，比很多同类网站好用太多了。',
    rating: 5,
  },
];

export const siteInfo = {
  name: '虚空韩漫网',
  tagline: '韩漫在线阅读 — 韩国漫画网免费在线观看的韩国漫画',
  description: '虚空韩漫网提供顺畅的韩漫在线阅读体验，聚合了韩国漫画网免费在线观看的韩国漫画，资源整合能力强。每日更新热门韩漫，涵盖浪漫爱情、奇幻冒险、热血动作、悬疑惊悚等多种题材。',
  email: 'contact@xkmanhua.com',
  founded: '2024年',
  totalManhwa: '5000+',
  dailyVisitors: '50万+',
};